import { request } from '@/utils/request'
//通知公告列表
export function getNoticeList(pageNo, pageSize) {
    return request({
        url: '/api/v1/ctnotice/noticeInfo/noticeList',
        method: 'get',
        params: {
            pageNo,
            pageSize
        }
    });
}
//通知公告详情
export function getNoticeDetails(noticeID) {
    return request({
        url: '/api/v1/ctnotice/noticeInfo/noticedetail',
        method: 'get',
        params: {
            noticeID
        }
    });
}
//行业新闻列表
export function getArticleList(pageNo, pageSize, articleType = 2) {
    return request({
        url: '/api/v1/master/news/getArticle',
        method: 'get',
        params: {
            pageNo,
            pageSize,
            articleType
        }
    });
}
//行业新闻详情
export function getArticleDetails(articleId) {
    return request({
        url: '/api/v1/master/news/detail',
        method: 'get',
        params: {
            articleId
        }
    });
}

//弹窗信息
export function getSystemRemind(remindType) {
    return request({
        url: '/api/v1/ctremind/systemRemind/getList',
        method: 'get',
        params: {
            remindType
        }
    });
}
